import moment from 'moment'

export const isSameDate = (date: Date | string = ''): boolean => {
  const currentDate = moment()
  const providedDate = moment(date)

  return currentDate.isSame(providedDate, 'day')
}
